<script>
export default {
  props: {
    name: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    default: Boolean,
  },
  computed: {
    _isTab() {
      return true;
    },
    localActive: {
      get() {
        return this.$route.query.tab === this.name;
      },
      set(active) {
        this.$set(this.$refs.tab, 'localActive', active);
        if (!active) {
          return;
        }
        this.changeTabRoute();
      },
    },
  },
  updated() {
    if (!this.$route.query.tab && this.default) {
      this.changeTabRoute();
    }
  },
  render(h) {
    return h(
      'b-tab',
      {
        ref: 'tab',
        props: {
          title: this.$props.title,
          active: this.$route.query.tab === this.name,
        },
        on: {
          click: () => this.changeTabRoute(),
        },
      },
      [this.$slots.default]
    );
  },
  methods: {
    changeTabRoute() {
      this.$router.replace({ query: { ...this.$route.query, tab: this.name } });
      this.$emit('click');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/RouteTab.vue